module.exports = __webpack_public_path__ + "assets/img/14_900_big.b351104c.jpg";